module.exports = __webpack_public_path__ + "static/img/kwh_item_image3.b2fc498.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/kwh_item_image3.png
// module id = xLCZ
// module chunks = 1